import { createStyles } from 'antd-style';

export const useCopilotStyle = createStyles(({ token, css }) => ({
  copilotChat: css`
    display: flex;
    flex-direction: column;
    background: ${token.colorBgContainer};
    color: ${token.colorText};
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  `,
  layout: css`
    width: 100%;
    min-width: 550px;
    height: 100vh;
    display: flex;
    background: ${token.colorBgContainer};
  `,
  // sider 样式
  sider: css`
    background: ${token.colorBgLayout}80;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 12px;
    box-sizing: border-box;
  `,
  logo: css`
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0 24px;
    box-sizing: border-box;
    gap: 8px;
    margin: 24px 0;

    span {
      font-weight: bold;
      color: ${token.colorText};
      font-size: 16px;
    }
  `,
  addBtn: css`
    background: #1677ff0f;
    border: 1px solid #1677ff34;
    height: 40px;
  `,
  chatHeader: css`
    height: 45px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px 0 16px;
    flex-shrink: 0;
  `,
  headerTitle: css`
    font-weight: 600;
    font-size: 15px;
  `,
  headerButton: css`
    font-size: 18px;
    color: ${token.colorTextSecondary};
    &:hover {
      color: ${token.colorPrimary};
    }
  `,
  conversations: css`
    width: 300px;
    .ant-conversations-list {
      padding-inline-start: 0;
    }
  `,
  newConversations: css`
    flex: 1;
    width: 280px;
    overflow-y: auto;
    margin-top: 12px;
    padding: 0;

    .ant-conversations-list {
      padding-inline-start: 0;
    }
  `,
  chatList: css`
    overflow: auto;
    padding-block: 16px;
    flex: 1;
    min-height: 0;

    /* 关键：修复气泡间距 */
    .ant-bubble {
      margin-bottom: 16px;
    }
    .ant-bubble:last-child {
      margin-bottom: 0;
    }
  `,
  chatWelcome: css`
    margin-inline: 16px;
    padding: 12px 16px;
    border-radius: 2px 12px 12px 12px;
    background: ${token.colorBgTextHover};
    margin-bottom: 16px;
  `,
  loadingMessage: css`
    background-image: linear-gradient(90deg, #ff6b23 0%, #af3cb8 31%, #53b6ff 89%);
    background-size: 100% 2px;
    background-repeat: no-repeat;
    background-position: bottom;
  `,
  chatSend: css`
    padding: 12px;
    padding-left: 30px;
    flex-shrink: 0;
  `,
  sendAction: css`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 8px;
  `,
  speechButton: css`
    font-size: 18px;
    color: ${token.colorText} !important;
  `,
  actionButton: css`
    color: ${token.colorTextSecondary};
    &:hover {
      color: ${token.colorPrimary};
      background: ${token.colorBgTextHover};
    }
  `,
  messageContent: css`
    line-height: 1.6;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    
    /* Markdown 内容样式 */
    h1, h2, h3, h4, h5, h6 {
      margin: 16px 0 8px 0;
      font-weight: 600;
    }
    
    p {
      margin: 8px 0;
    }
    
    ul, ol {
      margin: 8px 0;
      padding-left: 24px;
    }
    
    li {
      margin: 4px 0;
    }
    
    code {
      background: ${token.colorBgTextHover};
      padding: 2px 6px;
      border-radius: 3px;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    }
    
    pre {
      background: ${token.colorBgLayout};
      padding: 12px;
      border-radius: 6px;
      overflow: auto;
    }
    
    blockquote {
      border-left: 3px solid ${token.colorBorder};
      margin: 12px 0;
      padding-left: 12px;
      color: ${token.colorTextSecondary};
    }
  `
}));